import React, { useEffect, useState } from "react";
import { FaCalendarAlt } from "react-icons/fa";
import { RouteComponentProps } from "react-router";
import Card from "../../components/Card";
import ErroConsulta from "../../components/ErroConsulta";
import Loading from "../../components/Loading";
import PageHeader from "../../components/PageHeader";
import SubTitle from "../../components/SubTitle";
import Table from "../../components/Table";
import { useAuth } from "../../hooks/auth";
import { api } from "../../services/api";
import { semDadosNoProtheus } from "../../utils/consulta";
import { DateInfo } from "../ShareCapital/styles";

import { Container } from "./styles";

interface ActiveCardsProps {}

function ActiveCards({}: RouteComponentProps<ActiveCardsProps>) {
  const { user } = useAuth();
  const [cartoesativos, setCartoesativos] = useState<any>([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(false);
  const [tentativa, setTentativa] = useState(0);

  useEffect(() => {
    if (!user.matricula) return;

    let cancelado = false;
    setLoading(true);
    setErro(false);
    api
      .get("getCartoesAtivos", {
        params: {
          CODCLIENTE: user.matricula,
        },
      })
      .then((res: any) => {
        if (cancelado) return;
        setCartoesativos(res.data?.cartoesativos || []);
      })
      .catch((error) => {
        if (cancelado) return;
        setCartoesativos([]);
        setErro(!semDadosNoProtheus(error));
      })
      .finally(() => {
        if (!cancelado) setLoading(false);
      });

    return () => {
      cancelado = true;
    };
  }, [user.matricula, tentativa]);

  return (
    <Container>
      <PageHeader title="Cartões Ativos" />

      <SubTitle text={`Total de cartões: ${cartoesativos.length}`} icon={FaCalendarAlt} />
      <Card>
        {loading ? (
          <Loading />
        ) : erro ? (
          <ErroConsulta onTentarNovamente={() => setTentativa((t) => t + 1)} />
        ) : (
          <>
            <DateInfo>Emitido em: {new Date().toLocaleString()}</DateInfo>
            <Table>
              <tr>
                <th>Nome</th>
                <th>Perfil do Tipo</th>
                <th>Número</th>
              </tr>
              {cartoesativos.map((cartao) => (
                <tr>
                  <td>{cartao.nome}</td>
                  <td>{cartao.tipo}</td>
                  <td>{cartao.numero}</td>
                </tr>
              ))}
            </Table>
          </>
        )}
      </Card>
    </Container>
  );
}

export default ActiveCards;
